import React, { useState, useEffect } from 'react';
import {
  FaTachometerAlt,
  FaUserFriends,
  FaNewspaper,
  FaCalendarAlt,
  FaBullhorn,
  FaHandshake,
  FaCalendarCheck,
  FaFilm,
  FaSignOutAlt,
  FaTrophy,
  FaPodcast,
  FaTags,
  FaInfoCircle,
  FaImage,
  FaBars,
  FaTimes,
} from 'react-icons/fa';
import { AiOutlineTeam } from 'react-icons/ai';
import { FaPersonShelter } from 'react-icons/fa6';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo_black.png';
import apiService from '../redux/api-services/api-service'
import { useDispatch } from 'react-redux';
import { logout } from '../redux/reducers/adminSlice';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activePath, setActivePath] = useState(location.pathname);

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  const handleLogout = () => {
    apiService.clearAuthToken();
    dispatch(logout());
    navigate('/login');
  };

  const handleNavClick = (path, e) => {
    if (path === '#') {
      e.preventDefault();
    }
    setActivePath(path);
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const baseStyle = "flex items-center font-bold text-black transition-colors duration-200";
  const activeStyle = "text-pink-600";

  const menuItems = [
    // { path: "/dashboard", label: "Dashboard", icon: <FaTachometerAlt className="mr-3" /> },
    { path: "/news", label: "News", icon: <FaNewspaper className="mr-3" /> },
    { path: "/rj", label: "RJs", icon: <FaUserFriends className="mr-3" /> },
    { path: "/events", label: "Events", icon: <FaCalendarCheck className="mr-3" /> },
    { path: "/ads", label: "Ads", icon: <FaBullhorn className="mr-3" /> },
    { path: "/sponsors", label: "Sponsors", icon: <FaHandshake className="mr-3" /> },
    { path: "/movie", label: "Create Movie", icon: <FaFilm className="mr-3" /> },
    { path: "/programs", label: "Programs", icon: <FaCalendarAlt className="mr-3" /> },
    { path: "/contest", label: "Contest", icon: <FaTrophy className="mr-3" /> },
    { path: "/panorama", label: "Panoramas", icon: <FaImage className="mr-3" /> },
    { path: "/updateaboutus", label: "Update About Us", icon: <AiOutlineTeam className="mr-3" /> },
    { path: "/privacypolicy", label: "Privacy Policy", icon: <FaInfoCircle className="mr-3" /> },
    { path: "/press", label: "Press", icon: <FaPersonShelter className="mr-3" /> },
    { path: "/podcast", label: "Podcast", icon: <FaPodcast className="mr-3" /> },
    { path: "/category", label: "Category", icon: <FaTags className="mr-3" /> },
  ];

  return (
    <>
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-gray-100 shadow-md">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center">
            <img src={logo} alt="Radio Surabhi" className="h-10 w-auto mr-3" />
            <span className="text-black font-bold text-lg">Radio Surabhi</span>
          </div>
          <button
            onClick={toggleMobileMenu}
            className="text-black p-2 rounded-lg hover:bg-gray-200 transition-colors"
          >
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      <div className={`
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        fixed lg:relative top-16 lg:top-0 left-0 z-40
        w-64 h-[calc(100vh-4rem)] lg:h-screen
        bg-gray-100
        transition-transform duration-300 ease-in-out
        shadow-lg lg:shadow-none
      `}>
        <div className="hidden lg:block p-6 flex items-center justify-center w-60">
          <img src={logo} alt="Radio Surabhi" className="h-16 w-auto" />
        </div>

        <div className="lg:hidden p-6 flex items-center justify-center w-60 border-b border-gray-300">
          <img src={logo} alt="Radio Surabhi" className="h-14 w-auto" />
        </div>

        <nav className="px-4 pt-4 lg:pt-0 overflow-y-auto h-[calc(100%-8rem)]">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path} className="mb-3">
                <a
                  href={item.path}
                  onClick={(e) => handleNavClick(item.path, e)}
                  className={`
                    ${baseStyle} 
                    ${activePath === item.path ? activeStyle : ''}
                    p-3
                  `}
                >
                  {item.icon}
                  {item.label}
                </a>
              </li>
            ))}

            <li className="mb-3 mt-6 border-t border-gray-300 pt-4">
              <button
                onClick={handleLogout}
                className={`${baseStyle} w-full text-left p-3`}
              >
                <FaSignOutAlt className="mr-3" />
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </div>

      {isMobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;